import { __require as n } from "./_baseGetTag.js";
import { __require as u } from "./isObjectLike.js";
var r, o;
function b() {
  if (o) return r;
  o = 1;
  var i = n(), a = u(), t = "[object Boolean]";
  function s(e) {
    return e === !0 || e === !1 || a(e) && i(e) == t;
  }
  return r = s, r;
}
export {
  b as __require
};
